export const machineFmeaConstants = {
  GET_MACHINE_FMEA_REQUEST: 'GET_MACHINE_FMEA_REQUEST',
  GET_MACHINE_FMEA_SUCCESS: 'GET_MACHINE_FMEA_SUCCESS',
  GET_MACHINE_FMEA_FAILURE: 'GET_MACHINE_FMEA_FAILURE',

  GET_FMEA_TEMPLATES_REQUEST: 'GET_FMEA_TEMPLATES_REQUEST',
  GET_FMEA_TEMPLATES_SUCCESS: 'GET_FMEA_TEMPLATES_SUCCESS',
  GET_FMEA_TEMPLATES_FAILURE: 'GET_FMEA_TEMPLATES_FAILURE',
};

export const FMEA_SCOPE_OPTIONS = [
  { value: 'machine', label: 'Save for this machine', desc: 'Only visible to this machine' },
  { value: 'account', label: 'Save for my account', desc: 'Visible to all machines in your account' },
  { value: 'global', label: 'Save as global template', desc: 'Visible to all accounts and machines' },
];

export const FMEA_TABLE_COLS = [
  { key: 'sub_component', label: 'Sub-component', width: '12%', align: 'left' },
  { key: 'mode', label: 'Failure Mode & Effect', width: '18%', align: 'left' },
  { key: 'vibration_symptoms', label: 'Vibration Symptoms', width: '12%', align: 'left' },
  { key: 'twf_signature', label: 'TWF Signature', width: '12%', align: 'left' },
  { key: 'fft_signature', label: 'FFT Signature', width: '12%', align: 'left' },
  { key: 'fault_frequency', label: 'Fault Frequency', width: '10%', align: 'left' },
  { key: 'sensor_location', label: 'Sensor Location', width: '10%', align: 'left' },
  { key: 'severity', label: 'Sev', width: '70px', align: 'center', numeric: true },
  { key: 'occurrence', label: 'Occ', width: '70px', align: 'center', numeric: true },
  { key: 'detectability', label: 'Det', width: '70px', align: 'center', numeric: true },
  { key: 'rpn', label: 'RPN', width: '70px', align: 'center', numeric: true },
];

// Words that should be rendered fully uppercase in component subtype labels.
const SUBTYPE_ABBREVIATIONS = new Set(['ac', 'dc', 'sag', 'pac']);

export function formatComponentSubtype(subtype) {
  if (!subtype) return '';
  return subtype
    .split('_')
    .map(word => (SUBTYPE_ABBREVIATIONS.has(word.toLowerCase())
      ? word.toUpperCase()
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
    .join(' ');
}

// Free-text diagnostic fields edited as plain text inputs in the table
export const FMEA_TEXT_FIELDS = [
  'vibration_symptoms',
  'twf_signature',
  'fft_signature',
  'fault_frequency',
  'sensor_location',
];
